/**
 * Identificação legal do responsável pelo site.
 * Hoje: empresário em nome individual. Quando a empresa estiver constituída,
 * substituir por denominação social, NIPC e sede (mudar `taxLabel` para "NIPC"
 * e `addressLabel` para "Sede").
 */
export const COMPANY = {
  brand: "InvestCapital",
  legalName: "Fernando Alexandre Santos de Almeida",
  taxLabel: "NIF",
  taxId: "" /* NIF retirado por agora */,
  addressLabel: "Morada",
  address: "Rua Serra do Gerês, 36b, 2865-561 Fernão Ferro",
  email: "geral@investcapital.pt",
  phone: "+351 934 371 241",
  phoneHref: "tel:+351934371241",
  site: "www.investcapital.pt",
} as const;
